export default "__VITE_ASSET__D9Oe3Ver__"